import type { PropsWithChildren, RefObject } from "react";

import styles from "./HorizontalTrack.module.scss";

type HorizontalTrackProps = PropsWithChildren<{
  viewportRef: RefObject<HTMLDivElement | null>;
}>;

export function HorizontalTrack({ children, viewportRef }: HorizontalTrackProps) {
  return (
    <div
      ref={viewportRef}
      className={`${styles.viewport} h-viewport`}
      data-stage-viewport
    >
      <div className={`${styles.track} h-track`}>{children}</div>
    </div>
  );
}
